import productByCategoryView from "./productByCategoryView"
export default productByCategoryView;
